let nextId = 0;

const createFilter = ({ type, value }) => ({
  __typename: "Filter",
  id: nextId++,
  type,
  value,
});

export default createFilter;



// WEBPACK FOOTER //
// ./src/state/createFilter.js